import { render, staticRenderFns } from "./PbcOverlay.vue?vue&type=template&id=d0f42d9c&"
import script from "./PbcOverlay.vue?vue&type=script&lang=js&"
export * from "./PbcOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports